import {useRecoilLoadable} from 'shared/recoil/hooks/useRecoilLoadable';
import {userLookupReadSelector, userLookupSelector} from '../state/user-lookup';

export const useUserLookupLoadable = (userId: number) => {
    const {data, loading, error} = useRecoilLoadable({
        state: userLookupSelector(userId),
        loadable: userLookupReadSelector(userId),
    });
    return {
        user: data,
        loading,
        error,
    };
};